import React from 'react';

/**
 * Simple responsive image component - just uses base images
 */
export function SimpleResponsiveImage({ 
  src, 
  alt, 
  className = "", 
  style = {}, 
  loading = "lazy",
  ...props 
}) {
  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      className={className}
      style={style}
      {...props}
    />
  );
}

/**
 * Simple responsive picture component
 */
export const SimpleResponsivePicture = React.forwardRef(function SimpleResponsivePicture(
  {
    src,
    alt,
    className = "",
    style = {},
    imgStyle = {},
    imgClassName = "",
    loading = "lazy",
    ...props
  },
  ref
) {
  return (
    <picture className={className} style={style}>
      <img
        ref={ref}
        src={src}
        alt={alt}
        loading={loading}
        style={imgStyle}
        className={imgClassName}
        {...props}
      />
    </picture>
  );
});

/**
 * Simple responsive avatar component
 */
export function SimpleResponsiveAvatar({ 
  src, 
  alt, 
  className = "", 
  style = {}, 
  size = "medium",
  ...props 
}) {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{
        borderRadius: '50%',
        objectFit: 'cover',
        ...style
      }}
      {...props}
    />
  );
}

/**
 * Simple responsive hero component
 */
export function SimpleResponsiveHero({ 
  src, 
  alt, 
  className = "", 
  style = {}, 
  ...props 
}) {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{
        width: '100%',
        height: '300px',
        objectFit: 'cover',
        ...style
      }}
      loading="eager"
      {...props}
    />
  );
}

/**
 * Utility function to generate responsive image URLs
 */
export function generateResponsiveImageUrl(src, width, quality = 80) {
  return src; // Just return the original src
}

/**
 * Utility function to generate srcset string
 */
export function generateSrcset(src, widths = [400, 800, 1200], quality = 80) {
  return src; // Just return the original src
}